import React, { useState } from 'react';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { Button, Label, Loader } from '../../../../Components/uielements';
import { ButtonWrapper, ModalButtonWrapper, ModalWrapperInviteVisitor } from '../user.style';
import { OutlineButton } from '../../../../services/settings/appStyle/global.style';
import { IntlMessages } from '../../../../helper/langHelper';
import { DeleteIcon } from '../../../../Components/icons';

const InviteVisitorModal = ({ onClose, isProcessing, handleSendInvitationViaPhone }) => {
  const [currentPhone, setCurrentPhone] = useState('');
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [countryCode, setCountrycode] = useState();

  const isValidPhone = currentPhone.trim() && !phoneNumbers.includes(currentPhone);

  const handleAddPhoneNumber = () => {
    if (isValidPhone) {
      const formattedPhone = `+${currentPhone}`;
      setPhoneNumbers((prev) => [...prev, formattedPhone]);
      setCurrentPhone(countryCode?.dialCode);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleAddPhoneNumber(); // Add number when Enter is pressed
    }
  };

  const handleRemovePhoneNumber = (index) => {
    setPhoneNumbers((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <ModalWrapperInviteVisitor>
      <Label>Phone Number</Label>
      <ButtonWrapper>
        <PhoneInput
          country={'au'}
          onlyCountries={['us', 'au', 'in']}
          value={currentPhone}
          onChange={(value, countryCode) => {
            setCurrentPhone(value);
            setCountrycode(countryCode);
          }} // Update currentPhone state
          placeholder="Enter phone number"
          inputProps={{
            onKeyDown: handleKeyDown, // Listen for keypress events
          }}
        />
        <Button onClick={handleAddPhoneNumber} disabled={!isValidPhone} style={{ height: '100%' }}>
          Add
        </Button>
      </ButtonWrapper>

      <div>
        {phoneNumbers.map((phone, index) => (
          <div key={index} style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
            <Label>{phone}</Label>
            <DeleteIcon
              style={{ width: '19px', height: '19px', cursor: 'pointer', marginLeft: '10px' }}
              onClick={() => handleRemovePhoneNumber(index)}
            />
          </div>
        ))}
      </div>

      <ModalButtonWrapper style={{ marginTop: '20px' }}>
        <OutlineButton onClick={onClose}>Close</OutlineButton>{' '}
        {isProcessing ? (
          <Button varient="normal" disabled={isProcessing}>
            <div style={{ paddingRight: '10px' }}></div>
            <IntlMessages id="button.text.processing" />
            <Loader size="small" isNotRequiredLoadingText={true} />
          </Button>
        ) : (
          <Button varient="normal" onClick={() => handleSendInvitationViaPhone(phoneNumbers)}>
            Send
          </Button>
        )}
      </ModalButtonWrapper>
    </ModalWrapperInviteVisitor>
  );
};

export default InviteVisitorModal;
